// Single source of truth for the Simply AI + illustrative-estimate disclosures
// shown on every investor tool: the calculator pages, the lead-capture gate,
// the shareable-results bar, and each state variant that surfaces those tools.
// Never reword these in a component — import them.

export { QUOTE_AI_DISCLOSURE as SIMPLY_AI_DISCLOSURE } from "@/components/rates/QuoteAiPanel";

/** Short line used where a full paragraph would crowd the UI. */
export const SIMPLY_AI_SHORT_DISCLOSURE =
  "Simply AI gives educational explanations of the figures shown. It does not quote rates, confirm eligibility, or approve financing.";

/** Illustrative-estimate / broker / business-purpose disclosure for tool output. */
export const CALCULATOR_ESTIMATE_DISCLOSURE =
  "All figures are illustrative estimates based on the assumptions entered. They are not an approval, an offer of credit, or a commitment to lend, and may change. Final eligibility, rates, and terms are subject to a completed application, credit and property review, appraisal where required, and full underwriting. Simply Approved Mortgages LLC is a mortgage broker and arranges — but does not make — loans. Business-purpose, non-owner-occupied investment property financing only. Equal Housing Opportunity.";
